// extracted by mini-css-extract-plugin
export var errorIcon = "_ku-1";
export var nameLogo = "_ku-0";